import {ObjectMapping} from "../../../model/object-mapping";
import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";

export type ObjectMappingSelectorProps = {};

export const objectMappingSelector = () => createSelector(
  [getUseQueryResultData<ObjectMapping>],
  (data) => {
    return data ? transformObjectMapping(data) : undefined;
  }
);

export const objectMappingsSelector = () => createSelector(
  [getUseQueryResultData<ObjectMapping[]>],
  (data) => {
    return selectObjectMappingsAndTransform(
      data ?? [], {}
    );
  }
);

export const transformObjectMapping = (value: ObjectMapping): ObjectMapping => {
  return {...value}
}

export const selectObjectMappings = (values?: ObjectMapping[], selector?: ObjectMappingSelectorProps): ObjectMapping[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;
    return filterIn;
  });
};

export const selectObjectMappingsAndTransform = (values?: ObjectMapping[], selector?: ObjectMappingSelectorProps): ObjectMapping[] => {
  const selected = selectObjectMappings(values, selector);
  return selected.map(transformObjectMapping);
};
